module.exports = __webpack_public_path__ + "img/katarina_bedrooms_3.627e351b.jpg";